// Título/subtítulo del topbar por ruta — ver README.md (Shell: topbar).
// Puramente presentacional: no afecta ninguna lógica de negocio ni ruta existente.
const TITLES = [
	{ match: /\/credits\/add/i, title: 'Agregar crédito', sub: 'Registrar un nuevo crédito' },
	{ match: /\/credit\//i, title: 'Detalle de crédito', sub: 'Plan de pagos e historial' },
	{ match: /\/credits/i, title: 'Créditos', sub: 'Gestión y seguimiento de créditos' },
	{ match: /\/addclient/i, title: 'Agregar cliente', sub: 'Registrar un nuevo cliente' },
	{ match: /\/client\//i, title: 'Detalle de cliente', sub: 'Ficha completa del cliente' },
	{ match: /\/clients/i, title: 'Clientes', sub: 'Cartera de clientes' },
	{ match: /\/reports/i, title: 'Reportes', sub: 'Reportes de cartera y administración' },
	{ match: /\/(cashflow|cashregister|arqueouser|gastos|contabilidad|caja)/i, title: 'Administración', sub: 'Arqueos, gastos y flujo de efectivo' },
	{ match: /\/(users|rols|server)/i, title: 'Seguridad', sub: 'Usuarios, roles y servidor' },
	{
		match: /\/(sucursales|locations|tasa-interes|periodicidad|holidays|tasa-cambio)/i,
		title: 'Configuración',
		sub: 'Parámetros del sistema'
	},
	{ match: /\/account/i, title: 'Mi cuenta', sub: 'Datos de tu perfil' }
];

export const getPageTitle = (pathname, fallbackTitle) => {
	const found = TITLES.find((t) => t.match.test(pathname));
	if (found) {
		return found;
	}
	return { title: fallbackTitle || 'Panel Principal', sub: 'Resumen general de la cartera' };
};
